import { MhcGeographyEnum, MhcLocationFragment } from "graphqlApi/types";

import { STATE_LOCATION_NAME } from "common/constants";

export const getLocationName = (location: Partial<MhcLocationFragment>): string => {
  return location.geography === MhcGeographyEnum.State
    ? STATE_LOCATION_NAME
    : (location.name as string);
};
